var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from "lit/decorators.js";
import { css, html, LitElement } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { commonCssStyles } from "../../global-styles.js";
import "../avatar-icon/AvatarIcon.js";
import "../nav-menu-icon-button/NavMenuIconButton.js";
let NavMenuAvatarButton = class NavMenuAvatarButton extends LitElement {
    constructor() {
        super(...arguments);
        this.alert = false;
    }
    render() {
        return html `
      <div class="container">
        <nav-menu-icon-button
          id="menu-button"
          class="nav-button"
          text="${ifDefined(this.text)}"
        >
          <avatar-icon
            slot="icon"
            class="avatar-icon"
            initials="${ifDefined(this.initials)}"
            ?alert="${this.alert}"
            icon-size="small"
          ></avatar-icon>
        </nav-menu-icon-button>
      </div>
    `;
    }
    focus(options) {
        this.shadowRoot.getElementById("menu-button").focus(options);
    }
};
// noinspection CssUnresolvedCustomProperty
NavMenuAvatarButton.styles = [
    commonCssStyles,
    css `
      .container:hover .avatar-icon::part(circlecontainer) {
        background-color: var(--tones-lavender60-color);
      }

      .container:hover .nav-button::part(labellext) {
        color: var(--tones-lavender50-color);
      }

      .container:hover .nav-button::part(labelrule) {
        width: 100%;
      }

      .container:active .avatar-icon::part(circlecontainer) {
        background-color: var(--tones-lavender70-color);
      }

      .container:active .nav-button::part(labellext) {
        color: var(--tones-lavender60-color);
      }

      .container:active .nav-button::part(labelrule) {
        width: 100%;
        background-color: var(--tones-lavender60-color);
      }
    `,
];
__decorate([
    property()
], NavMenuAvatarButton.prototype, "text", void 0);
__decorate([
    property()
], NavMenuAvatarButton.prototype, "initials", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], NavMenuAvatarButton.prototype, "alert", void 0);
NavMenuAvatarButton = __decorate([
    customElement("nav-menu-avatar-button")
], NavMenuAvatarButton);
export { NavMenuAvatarButton };
